export default __webpack_public_path__ + "static/media/Close_Button.ee2adbb3.svg";